<template>
    <div class="table-page-wrapper">
      <date-format-select @changeDateFormatData="changeDateFormatData($event.dateFormatId)" style="margin-right: 15px;margin-bottom: 15px;" />
        <search-channel-select v-model="listQuery.channelId" style="margin-right: 15px;margin-bottom: 15px;" />
        <search-channel-slot-select v-model="listQuery.slotId"   style="margin-right: 15px;margin-bottom: 15px;" />
          <search-dsp-select v-model="listQuery.dspId" style="margin-right: 15px;margin-bottom: 15px;" />
          <search-dsp-slot-select
            v-model="listQuery.dspSlotId"
            :dsp-id="listQuery.dspId"
          />
          <el-date-picker
        v-model="date"
        type="datetimerange"
        @change="changeDate"
        :shortcuts="shortcuts"
        :editable="false"
        unlink-panels
        style="width:270px;margin-right: 15px;"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
          <el-button @click="search" type="primary"   style="margin-bottom: 15px;">搜索</el-button>
          <el-button
         @click="downExcel('/reportRule/list/xlsx', '下载规则报表', downParam)"
          type="primary" >下载</el-button>
        <div class="table-wrapper">
        <el-table :data="tableData" class="js-table" border >
        <el-table-column prop="timeHour"           align="center"  label="请求时间"></el-table-column>
        <el-table-column prop="channelName"        align="center"  label="Channel名称"></el-table-column>
        <el-table-column prop="dspName"            align="center"  label="DSP名称"></el-table-column>
        <el-table-column prop="slotName"           align="center"  label="广告位名称"></el-table-column>
        <el-table-column prop="dspSlotName"        align="center"  label="DSP广告位名称"></el-table-column>
        <el-table-column prop="mangoCpuNum"        align="center"  label="manggo_cpu_num（%）"></el-table-column>
        <el-table-column prop="mangoIdfv"          align="center"  label="manggo_idfv（%）"></el-table-column>
        <el-table-column prop="deviceStartSec"     align="center"  label="dss(%)"></el-table-column>
        <el-table-column prop="deviceNameMd5"      align="center"  label="dnm(%)"></el-table-column>
        <el-table-column prop="hardwareMachine"    align="center"  label="hm(%)"></el-table-column>
        <el-table-column prop="physicalMemoryByte" align="center"  label="pmb(%)"></el-table-column>
        <el-table-column prop="harddiskSizeByte"   align="center"  label="hsb(%)"></el-table-column>
        <el-table-column prop="systemUpdateSec"    align="center"  label="sus(%)"></el-table-column>
        <el-table-column prop="hardwareModel"      align="center"  label="h-model(%)"></el-table-column>
        <el-table-column prop="country"            align="center"  label="country(%)"></el-table-column>
        <el-table-column prop="language"           align="center"  label="language(%)"></el-table-column>
        <el-table-column prop="timeZone"           align="center"  label="time-zone(%)"></el-table-column>
      </el-table>
    </div>
      <el-pagination
                :current-page.sync="listQuery.pageNum"
                :page-sizes="[10, 20, 30, 50]"
                :page-size.sync="listQuery.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="sizeChange"
                @current-change="currentChange"
                style="text-align:center;margin-top:10px;margin-bottom: 50px;"
              />
    </div>
    </template>
    <script>
    import {getReportRule} from '@/api/manage/reportRule/reportRule'
    import { formatDate, PURE_DATETIME_H_PATTERN ,PURE_DATE_PATTERN} from '@/util/format'
    import {downExcelMixin} from "@/mixins/downExcel";
    import DateFormatSelect from "./components/DateFormatSelect.vue";
    import SearchChannelSelect from "@/components/SearchChannelSelect";
    import SearchDspSlotSelect from "@/components/SearchDspSlotSelect";
    import SearchDspSelect from "@/components/SearchDspSelect";
    import SearchChannelSlotSelect from "@/components/SearchChannelSlotSelect";
    import BaseDatePicker from "@/components/BaseDatePicker";
    export default{
        name: 'clickAction',
        components: {
        DateFormatSelect,
        SearchChannelSelect,
        SearchDspSelect,
        SearchDspSlotSelect,
        BaseDatePicker,
        SearchChannelSlotSelect,
      },
        mixins: [downExcelMixin],
        data(){
            return{
              date: '',
                tableData:[],
                listQuery:{
                  showType:2,
                  pageNum:1,
                  pageSize:30,
                },
                total:undefined,
                shortcuts: [
        {
          text: '今天',
          value: (() => {
            const end = new Date()
            const start = new Date()
            return [start, end]
          })()
        }, {
          text: '昨天',
          value: (() => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24)
            end.setTime(end.getTime() - 3600 * 1000 * 24)
            return [start, end]
          })()
        }, {
          text: '最近一周',
          value: (() => {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6)
            return [start, end]
          })()
        }
      ]
            }
        },
      computed:{
        downParam () {
            const params = Object.assign({}, this.listQuery)
            params.pageSize = this.total
            params.pageNum = 1
            return params
    }
        },
        methods:{
          //获取列表
          async getData(){
            this.changeDate(this.date)
            const res = await getReportRule(this.listQuery)
            this.tableData = res.data.records
            this.total = res.data.total
          },
          //页码切换
          sizeChange(e){
            this.listQuery.pageSize = e
            this.getData()
          },
          //当前页切换
          currentChange(e){
            this.listQuery.pageNum=e
            this.getData()
          },
          //搜索
          search(){
            this.listQuery.pageNum = 1
            this.getData()
          },
          //处理日期
          changeDateFormatData(dateFormatId) {
          this.listQuery.showType = dateFormatId
        },
        //修改时间
        changeDate (date) {
      if (date&&this.listQuery.showType===1) {
        this.listQuery.startTime = formatDate(date[0], PURE_DATETIME_H_PATTERN)
        this.listQuery.endTime = formatDate(date[1], PURE_DATETIME_H_PATTERN)
      }
      else if(date&&this.listQuery.showType===2){
        this.listQuery.startTime = formatDate(date[0], PURE_DATE_PATTERN)
        this.listQuery.endTime = formatDate(date[1], PURE_DATE_PATTERN)
      }
    },
      },
        mounted(){
          this.$nextTick(() => {
        this.date = [new Date(), new Date()]
        this.changeDate(this.date)
        this.getData()
    })
        },

    }
    </script>

    <style lang="scss" scoped>
    .search-wrapper {
      padding: 15px 15px 5px;
      margin-bottom: 10px;
      background: #ffffff;

      &>* {
        margin-right: 15px;
        margin-bottom: 10px;

        &:last-child {
          margin-right: 0;
        }
      }

      &>.el-select,
      &>.el-input {
        width: 220px;
      }
    }

    .table-wrapper {
      padding: 15px;
      background: #ffffff;

      .table__operation {
        padding-bottom: 10px;
      }
    }

    .el-pagination {
      text-align: right;
    }

    ::v-deep.el-table__placeholder {
      display: none;
    }

    ::v-deep.el-table__expand-icon {
      width: auto !important;
    }
    </style>
